import React, { useRef, Children, Component } from 'react';
import { motion, useInView } from 'framer-motion';
interface TextRevealProps {
  text: string;
  className?: string;
  delay?: number;
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'p' | 'span' | 'div';
  splitBy?: 'word' | 'line' | 'character';
}
export function TextReveal({
  text,
  className = '',
  delay = 0,
  as: Component = 'p',
  splitBy = 'word'
}: TextRevealProps) {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-10%'
  });
  const words = text.split(' ');
  // Animation variants
  const container = {
    hidden: {
      opacity: 0
    },
    visible: (i = 1) => ({
      opacity: 1,
      transition: {
        staggerChildren: 0.05,
        delayChildren: delay * i
      }
    })
  };
  const child = {
    hidden: {
      y: '100%',
      opacity: 0
    },
    visible: {
      y: '0%',
      opacity: 1,
      transition: {
        type: 'spring',
        damping: 20,
        stiffness: 100,
        duration: 0.6
      }
    }
  };
  if (splitBy === 'word') {
    return <Component ref={ref} className={className} data-id="element-121">
        <motion.span variants={container} initial="hidden" animate={isInView ? 'visible' : 'hidden'} className="inline-block" data-id="element-122">
          {words.map((word, index) => <span key={index} className="inline-block overflow-hidden align-bottom mr-[0.25em] last:mr-0 pt-[0.15em]" data-id="element-123">
              <motion.span variants={child} className="inline-block pl-[3px] pr-[3px]" data-id="element-124">
                {word}
              </motion.span>
            </span>)}
        </motion.span>
      </Component>;
  }
  // Fallback for simple fade if not splitting by word (can be expanded)
  return <Component ref={ref} className={className} data-id="element-125">
      <motion.span initial={{
      opacity: 0,
      y: 20
    }} animate={isInView ? {
      opacity: 1,
      y: 0
    } : {
      opacity: 0,
      y: 20
    }} transition={{
      duration: 0.6,
      delay,
      ease: [0.25, 0.46, 0.45, 0.94]
    }} data-id="element-126">
        {text}
      </motion.span>
    </Component>;
}